import React from 'react';
import { LobsterFuelPriceSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'fuel-price';
const SLUG_DB = 'fuel-price-db';

const DEFAULT_FUEL_PRICE = 3.0;

interface FuelPriceData {
  updatingParams?: boolean;
  fuelPriceUpdatingParams?: boolean;
  lobsterDisabled?: boolean;
}

export default function FuelPrice(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<FuelPriceData>(props);

  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const formDbValue = formContext?.values?.[SLUG_DB] as number | undefined;
  const fuelPrice = formValue ?? DEFAULT_FUEL_PRICE;
  const dbFuelPrice = formDbValue ?? fuelPrice;
  const updatingParams =
    data.updatingParams ?? data.fuelPriceUpdatingParams ?? data.lobsterDisabled ?? false;

  const handleFuelPriceChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = parseFloat(e.target.value);
      formContext?.setValue(SLUG, value);
    },
    [formContext]
  );

  return (
    <LobsterFuelPriceSlider
      fuelPrice={fuelPrice}
      dbFuelPrice={dbFuelPrice}
      handleFuelPriceChange={handleFuelPriceChange}
      updatingParams={updatingParams}
    />
  );
}
